export const EDITORIAL_URL_BASE = '/editorial';
export const GREATEST = 'greatest';

export const EDITORIAL_SECTION_TYPE = Object.freeze({
  AUDIO: 'AudioSection',
  AUTHOR_CREDIT: 'AuthorCreditSection',
  FULL_IMAGE: 'FullImageSection',
  IMAGE_SET: 'ImageSetSection',
  INTRODUCTION: 'IntroductionSection',
  QA: 'QuestionAnswerSection',
  QUOTE: 'QuoteSection',
  TEXT: 'TextSection',
  TOP_SHOES: 'TopShoesSection',
  VIDEO_HERO: 'VideoHeroSection',
  SPACE: 'SpaceArticleSection',
});
